import type {
  LinkedSessionRequest,
  LinkedSessionResponse,
} from "@shared/types/common";
import apiProxy from "@shared/utils/api-proxy";

export const sessionsService = {
  getLinkedSession: async (
    getLinkedSessionRequest: LinkedSessionRequest,
  ): Promise<LinkedSessionResponse | null> =>
    await apiProxy.post(`session/getLinkedSession`, getLinkedSessionRequest),
};
